import shipvistaAPI from "../shipvistaAPI";

export const getAllStoresService = () => shipvistaAPI.get(`/Marketplaces`);
